export const COMMISSION = 0.1;
export const AIRBNB_GUEST = 0.141;
export const AIRBNB_HOST = 0.03;
// Vrbo: ~12% host commission (new model) + traveler service fee (varies; ~10% used as an estimate)
export const VRBO_GUEST = 0.1;
export const VRBO_HOST = 0.12;

export function quote(price, cleaning, nights) {
  const nightly = price * nights;
  const total = nightly + (cleaning || 0);
  return {
    nights,
    nightly,
    cleaning: cleaning || 0,
    total,
    airbnbGuestFee: total * AIRBNB_GUEST,
    airbnbTotal: total * (1 + AIRBNB_GUEST),
    savings: total * AIRBNB_GUEST,
    commission: total * COMMISSION,
    hostNet: total * (1 - COMMISSION),
    airbnbHostFee: total * AIRBNB_HOST,
    airbnbAllFees: total * (AIRBNB_GUEST + AIRBNB_HOST),
    vrboGuestFee: total * VRBO_GUEST,
    vrboTotal: total * (1 + VRBO_GUEST),
    vrboHostFee: total * VRBO_HOST,
    vrboAllFees: total * (VRBO_GUEST + VRBO_HOST),
  };
}

export const AMENITIES = [
  "Wifi", "Kitchen", "Free parking", "Air conditioning", "Heating", "Washer", "Dryer", "Workspace",
  "Pool", "Hot tub", "BBQ grill", "Fireplace", "Beach access", "Lake access", "Ocean view", "Pets allowed",
  "EV charger", "Gym", "Elevator", "Crib",
];

export const PROPERTY_TYPES = ["House", "Apartment", "Cabin", "Cottage", "Villa", "Loft", "Room"];
